<template>
  <div class="sortPanel">
    <div class="orderPanel">
<input type="button" value="Reset" class="sortButton" @click="originList" :class="{orderSelected:selectedInit}">
<input type="button" value="Newest" class="sortButton" @click="sortByNew" :class="{orderSelected:selectedNew}" v-if="isSelectedNew">
<input type="button" value="Oldest" class="sortButton" @click="sortByOld" :class="{orderSelected:selectedOld}" v-if="isSelectedOld">
<label class="" :class="{orderSelected:sortedAny}" aria-label="リストを絞り込む"><input type=text name="free" placeholder="" class="searchInput" ref="searchChar" @keydown.enter="searchBy()" aria-label="リスト絞り込み要素入力" placeholder="絞り込む文言を入力ください">
<button type="button" class="sortButton" @click="searchBy()" aria-label="リスト絞り込みボタン">
<img :src="setImageFullPath('components/sortPanel/filter.svg')" alt="フィルタリングアイコン">
</button>
</label>
    </div>

<!--&Lt; &lt; &gt; &Gt;-->
    <div class="pnPanel" v-if="setPagination">

			<div class="pnPanelPageNumber">
<a href="javascript:void(0);" class="forTip" @mouseenter="openTip" @mouseleave="closeTip" @focus="openTip" @blur="closeTip" @keyup.esc="closeTip" aria-describedby="">Page<span class="tip" role="tooltip">* 頁を切り替えます。<br>数値入力後、[ enter / return ]で確定します。</span></a><input type=number name="page" @keydown.enter="changePageDisplay()" aria-label="頁入力" placeholder="頁" :value="currentPage" ref="currentPageInfo">
			</div>

      <div class="pnPanelButtonSize">
        <button type="button" class="prev" v-if="showPrevButton" @click="firstPage()"><img :src="setImageFullPath('components/sortPanel/first.svg')" alt="１ページ"></button>
      </div>
      <div class="pnPanelButtonSize">
        <button type="button" class="prev" v-if="showPrevButton" @click="prevPage()"><img :src="setImageFullPath('components/sortPanel/prev.svg')" alt="前ページ"></button>
      </div>
      <ul>
<li v-for="j in setPanelNumber()" :key="j" :class="{activeColor:selectedNumber(j)}"><button @click="setPage(j)">{{j}}</button></li>
      </ul>

      <div class="pnPanelButtonSize">
        <button type="button" class="next" v-if="showNextButton" @click="nextPage()"><img :src="setImageFullPath('components/sortPanel/next.svg')" alt="次ページ"></button>
      </div>
      <div class="pnPanelButtonSize">
        <button type="button" class="next" v-if="showNextButton" @click="lastPage()"><img :src="setImageFullPath('components/sortPanel/last.svg')" alt="最後ページ"></button>
      </div>
    </div>

    <div class="itemsPanel" v-if="setPagination">
			<div class="pnPanelPageRange">
<a href="javascript:void(0);" class="forTip" @mouseenter="openTip" @mouseleave="closeTip" @focus="openTip" @blur="closeTip" @keyup.esc="closeTip" aria-describedby="">Items<span class="tip" role="tooltip">* 頁あたりの表示項目数を設定します。<br>数値入力後、[ enter / return ]で確定します。</span></a><input type=number name="items" @keydown.enter="arrangeDisplay()" aria-label="ページあたりの項目数" placeholder="表示数" :value="localPageRange" ref="pageRangeInfo">
			</div>
			<div class="pnPanelItemsNumber"><p>{{displayItemsStartNumber}} - {{displayItemsEndNumber}} / {{itemNumbers}}</p>
			</div>
    </div>

    <div class="pnPanel pnPanelBottom" v-if="setPagination">
      <div class="pnPanelButtonSize">
        <button type="button" class="prev" v-if="showPrevButton" @click="firstPage()"><img :src="setImageFullPath('components/sortPanel/first.svg')" alt="１ページ"></button>
      </div>
      <div class="pnPanelButtonSize">
        <button type="button" class="prev" v-if="showPrevButton" @click="prevPage()"><img :src="setImageFullPath('components/sortPanel/prev.svg')" alt="前ページ"></button>
      </div>
      <ul>
<li v-for="j in setPanelNumber()" :key="j" :class="{activeColor:selectedNumber(j)}"><button @click="setPage(j)">{{j}}</button></li>
      </ul>
      <div class="pnPanelButtonSize">
        <button type="button" class="next" v-if="showNextButton" @click="nextPage()"><img :src="setImageFullPath('components/sortPanel/next.svg')" alt="次ページ"></button>
      </div>
      <div class="pnPanelButtonSize">
        <button type="button" class="next" v-if="showNextButton" @click="lastPage()"><img :src="setImageFullPath('components/sortPanel/last.svg')" alt="最後ページ"></button>
      </div>
    </div>


    <div v-if="setListHeader">
      <ul class="listItems listHeader" >
				<li>
<p v-for="(k, index) in listHeader" :key="index" @click="orderItem(index)" :class="makeClassName(k.element)">
{{k.title}}
</p>
				</li>
      </ul>
		</div>


  </div>
</template>

<script>
/* ListView.vue
与えられたlist(元jsonデータの連想配列）を呼び出し側と連携し、リスト表示＆検出＆並び替えを行うUI
プラス
テーブルリスト項目での昇降順+登録順の並び替えも実現する

親側必要なもの：
<template>
・コンポーネント呼び出し（呼び出し用メソッド、元リストと共に）
・リスト表示用v-for（表示用listループ）
<script>
・import ListView
・元リスト読み込み処理
・components:
ListView
・data:
元list
表示用（変更list）list
・beforeMount:
表示用リストセット
・method:
子呼び出し用イベント（表示用リストに変更リストセット）
*/
export default {
  name: 'sortpanel',
  props:{
    origin: {
        type:Array,
    },
    panel: {
        type:Object,
    },
/*ページネーション用*/
    pageRange: { //0:すべて 1以上:1ページあたりの表示数
      type:Number,
    },
		pageNum: {	//urlパラメータではじめに指定されるリストページ番号
      type:Number,
		},
/*リストヘッダ用*/
		listHeader:{
			type:Array,
		}
  },
  data: function () {
    return {
      displayList:[], //検出並び替えを行なった全体リスト
      pageView:[], //上記から部分抜き出しをした表示用のリスト
/*検出/並び替え用*/
      anySort:1, /*1:降順 0:昇順 2:自由検出*/
      selectedInit:false,
      selectedNew:true,
      selectedOld:false,
      sortedAny:false,
      isSelectedNew:true,
      isSelectedOld:true,
/*ページネーション用*/
      currentPage:1,           //選択ページ番号
			preCurrentPage:0,			//前選択（表示）頁番号 pageRange変更時に使用する
      pageNumbers:0,           //総ページ数
			itemNumbers:0,         //表示項目総数
			localPageRange:10,						//1ページあたりの項目数 ローカル値 (=pageRange)
    }
  },
	watch:{
			pageNum(newValue, oldValue){
//props pageNumが親の値変更にブラウザー戻るボタン時反応していないので、watchする
//this._log("SORTPANEL", 'new:', newValue, 'old:', oldValue)
					this.setPage(newValue)
			}
	},
  computed: {
    setPagination:function() {
      return this.pageRange > 0
    },
    showPrevButton() {
      return this.currentPage > 1
    },
    showNextButton() {
      return this.currentPage < this.pageNumbers
    },
    itemsCount:function() {
      return this.displayList.length
    },
//ページネーション表示数設定 　奇数設定 現状5で調整
		pnPanelButtonNumbers:function() {
			return this.pageNumbers < 5? this.pageNumbers:5
		},
		displayItemsStartNumber:function() {
			return (this.currentPage-1) * this.localPageRange + 1
		},
		displayItemsEndNumber:function() {
			let aEndNumber = (this.currentPage-1) * this.localPageRange + this.localPageRange
			return  aEndNumber < this.itemNumbers?aEndNumber:this.itemNumbers
		},
		setListHeader:function() {
			return this.listHeader !== undefined
		},
  },
  beforeMount:function() {this._log("beforeMount "+this.$options.name)
    this.resetList()
this._log("+++++++++++++++++++++++LIST"+this.displayList.length)

//ページ初期構築時の情報をセットする
    if(this.displayList.length != 0 && this.displayList[0].date != null) {
//dateがある場合は、降順で初期レイアウト

			this.localPageRange = this.pageRange

      this.sortByNew()
      this.sortByOrder()
    } else {
//dateがない場合は、リストは何もせず、操作パネルのup/downを非表示にする
      this.isSelectedNew = false
      this.isSelectedOld = false
    }
//urlパラメータで指定されたpageをセットする
		this.currentPage = this.pageNum

    this.setPageNumbers()    //パネル用 ページ数セット
		this.tagJumpPage()
    this.changePage()        //表示用 ページセット

		/*リスト表示用のヘッダ幅をcssにセットする*/
		if(this.listHeader !== undefined) {
			document.documentElement.style.setProperty('--listHeaderWidth',  100 / this.listHeader.length + '%')
		}
  },
  mounted: function() {this._log("mounted "+this.$options.name)
    this.$emit("parentMethod", this.pageView, this.displayList, this.currentPage)  //親に変更を伝える
		this.setItemNumbers()
  },
  beforeUpdate:function() {this._log("beforeUpdate "+this.$options.name)
//this._log(this.pageNum)
	},
  updated:function() {this._log("updated "+this.$options.name)
/*この状態だと*/
    this.sortByOrder()
    this.setPageNumbers()    //パネル用 ページ数セット
    this.changePage()        //表示用 ページセット
    this.$emit("parentMethod", this.pageView, this.displayList, this.currentPage, this.preCurrentPage)  //親に変更を伝える

		this.setItemNumbers()
  },
  methods:{
/*表示物総数を保持する*/
		setItemNumbers:function() {
			if( this.itemNumbers != this.displayList.length) {
				this.itemNumbers = this.displayList.length
			}
this._log("NUMBERS"+this.itemNumbers)
		},


    originList() {
/*すでに選択されていたの再押下で何もしないようにしたい*/
      this.anySort = -1
      this.$refs.searchChar.value = ""
this.selectedInit = true
this.selectedNew = false
this.selectedOld= false
this.sortedAny = false

this.currentPage = 1 //ページネーションイニシャル

//		this.setListHeader()
    },
    sortByNew() {
/*すでに選択されていたの再押下で何もしないようにしたい*/
      this.anySort = 1
this.selectedInit = false
this.selectedNew = true
this.selectedOld= false

this.currentPage = 1 //ページネーションイニシャル
    },
    sortByOld() {
/*すでに選択されていたの再押下で何もしないようにしたい*/
      this.anySort = 0
this.selectedInit = false
this.selectedNew = false
this.selectedOld= true

this.currentPage = 1 //ページネーションイニシャル
    },
    searchBy() {
/*すでに選択されていたの再押下で何もしないようにしたい*/
      if(this.$refs.searchChar.value) {
        this.anySort = 2
this.selectedInit = false
this.sortedAny = true
      } else {
        this.anySort = -1
this.selectedInit = true
this.selectedNew = false
this.selectedOld= false
this.sortedAny = false
      }
this.currentPage = 1 //ページネーションイニシャル
    },
    sortByOrder() {
      switch(this.anySort) {
        case 0:/*降順*/
        case 1:/*昇順*/
          this.displayList.sort((first,second) => {
            return (this.anySort == 1)? this.newOrder(first.date, second.date):this.oldOrder(first.date, second.date)})
          break;
        case 2:/*任意検出*/
          this.searchByChar(this.$refs.searchChar.value)
          break;
        default:
           this.resetList()
      }
    },
    newOrder(firstDate, secondDate) {
      let aFirstDate = new Date(firstDate)
      let aSecondDate = new Date(secondDate)

      let aFirst = aFirstDate.getTime()
      let aSecond = aSecondDate.getTime()
      if(aFirst > aSecond) {
        return -1
      } else if(aFirst < aSecond) {
        return 1
      } else {
        return 0
      }
    },
    oldOrder(firstDate, secondDate) {
      let aFirstDate = new Date(firstDate)
      let aSecondDate = new Date(secondDate)

      let aFirst = aFirstDate.getTime()
      let aSecond = aSecondDate.getTime()
      if(aFirst > aSecond) {
        return 1
      } else if(aFirst < aSecond) {
        return -1
      } else {
        return 0
      }
    },
    searchByChar(aChar) {
/*続けて検出するときのために、フラグをクリアする*/
      this.anySort = 0
      this.displayList = this.displayList.filter(aObject => {
let aArray = Object.values(aObject)
let aString = aArray.toString()
let aResults = aString.indexOf(aChar)
return (aResults > 0)? true:false})

/* 一気に書くとエラーになるのでとりあえず上記で
(Object.values(aObject).toString().indexOf(aChar) > 0)? true:false})*/
    },
    resetList() {
      this.displayList = Object.assign([], this.origin)
    },
    changePage() { //該当部分のリストを取り出す
      if(this.localPageRange > 0) {
        //ページ番号から、リスト内のデータを抜き出す
        let startRow = (this.currentPage -1) * this.localPageRange
        let endRow = startRow + this.localPageRange
this._log("++++++++++++++++++++++++CHANGE PAGE")
this._log(this.currentPage)
this._log(this.localPageRange)
this._log(startRow)
this._log(endRow)
        this.pageView = this.displayList.slice(startRow, endRow)
      } else {
        this.pageView = this.displayList
      }
    },
    setPageNumbers() { //表示ページ数を算出する
      let aLastPage = ((this.displayList.length % this.localPageRange) > 0)? 1:0
      this.pageNumbers = parseInt(this.displayList.length / this.localPageRange) + aLastPage
    },
    setPage(aNumber) {
      this.currentPage = aNumber
    },
    firstPage() {
      this.currentPage = 1
    },
    prevPage() {
      this.currentPage = (this.currentPage - 1 <= 0 )? 1: this.currentPage -1
    },
    nextPage() {
      this.currentPage = (this.currentPage + 1 > this.displayList.length )? this.displayList.length: this.currentPage +1
    },
    lastPage() {
      this.currentPage = this.pageNumbers
    },

    setPanelNumber() { //パネル表示数字を編集する
//現ページ番号から表示番号の配列を生成する
      let startNumber = 1   //パネル表示の始まり番号
      let noScrollBuffer = parseInt(this.pnPanelButtonNumbers / 2) + 1  //パネル内並び番号の変更が発生しない値 5なら3 7なら4
//始まりのチェック
      if(this.currentPage > noScrollBuffer) {
        startNumber = this.currentPage - noScrollBuffer + 1
      }
//終わりのチェック
      if(this.currentPage > this.pageNumbers - noScrollBuffer + 1) {
//pnPanelButtonNumbersに満たない場合も中に入る
        startNumber = this.pageNumbers - this.pnPanelButtonNumbers + 1
      }
      let res = []  //初期化 パネル表示用数字配列を作成
      if(startNumber > 0) {
        for(let i = startNumber; i < startNumber+this.pnPanelButtonNumbers; i++) {
          res.push(i)
        }
      } else {
        for(let i = 1; i < this.pageNumbers+1; i++) {
          res.push(i)
        }
      }
      return res
    },
    selectedNumber(aNumber) {
      return this.currentPage == aNumber
    },
		makeClassName:function(aName) {
			return "_"+aName
		},
		tagJumpPage() {
			let aHash = this.$route.hash
			if( aHash != "") {
				aHash = aHash.replace("#","")
//this._log(this.localPageRange)
//console.dir(this.displayList)
				let aPosInList = this.displayList.findIndex((i) => i.id === aHash) +1
//this._log(aPosInList)
				this.currentPage = Math.floor(aPosInList/this.localPageRange) 
				this.currentPage += (aPosInList%this.localPageRange)?1:0
//this._log(this.currentPage)
			}
		},
		changePageDisplay() {
			let aCurrentPage = this.currentPage
			aCurrentPage = Number(this.$refs.currentPageInfo.value)
			aCurrentPage = aCurrentPage == 0?"1":aCurrentPage
			aCurrentPage = aCurrentPage > this.pageNumbers? this.pageNumbers:aCurrentPage
			this.$refs.currentPageInfo.value = aCurrentPage
			this.currentPage = aCurrentPage
			//this.changePage()
		},
		arrangeDisplay() {
this._log("+++++++++++++++++++++++++++arrangeDisplay")
			let aPageRange = this.localPageRange
			aPageRange = Number(this.$refs.pageRangeInfo.value)
			aPageRange = aPageRange == 0?this.pageRange:aPageRange
			this.$refs.pageRangeInfo.value = aPageRange
			this.localPageRange = aPageRange

			this.preCurrentPage = this.currentPage //変更前頁番号を保持
			this.currentPage = 1 																//表示頁を1に初期化
			//this.changePage()
			this.$emit("parentMethod", this.pageView, this.displayList, this.currentPage)  //親に変更を伝える
		},
  },
}
</script>


<style>
</style>
